import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitRegistryDesignBox } from './TraitRegistryDesignBox';
import { TraitRegistryDesignFont } from './TraitRegistryDesignFont';
export class TraitRegistryDesign extends TraitRegistryCategory {
    label = 'Design';
    c_font = new TraitRegistryDesignFont(this);
    c_borders = new TraitRegistryDesignBox(this);
}
